export const initClickOutsideDirective = (Vue) => {
  Vue.directive('click-outside', {
    beforeMount: function (el, binding) {
      el.clickOutsideEvent = function (event) {
        if (!(el === event.target || el.contains(event.target))) {
          binding.value(event);
        }
      };
      document.body.addEventListener('click', el.clickOutsideEvent);
    },
    beforeUpdate: function (el) {
      document.body.removeEventListener('click', el.clickOutsideEvent);
    },
  });
};
